var map = {
	"./AssemblyPoint/legend.png": 914,
	"./Callpoint/legend.png": 915,
	"./ControlPanel/legend.png": 916,
	"./EmergencyLighting-HQ/legend.png": 917,
	"./Evacuation-Bed/legend.png": 918,
	"./Evacuation-Chair/legend.png": 919,
	"./Exit-Right/legend.png": 920,
	"./Exit-Stairs-Up/legend.png": 921,
	"./Exit-Up/legend.png": 922,
	"./Exit/legend.png": 923,
	"./Fire-Alarm/legend.png": 924,
	"./Fire-Door-FD30/legend.png": 925,
	"./Fire-Door-FD60/legend.png": 926,
	"./Fire-Door/legend.png": 927,
	"./Fire-Extinguisher-Dry-Powder/legend.png": 928,
	"./Fire-Extinguisher-Foam/legend.png": 929,
	"./Fire-Extinguisher-Water-Mist/legend.png": 930,
	"./Fire-Extinguisher-Water/legend.png": 931,
	"./Fire-Extinguisher-Wet-Chemical/legend.png": 932,
	"./Fire-Extinguisher/legend.png": 933,
	"./Fire-Hose/legend.png": 934,
	"./Fire-Ladder/legend.png": 935,
	"./Fire-Suppression-System/legend.png": 936,
	"./First-Aid-Green/legend.png": 937,
	"./First-Aid-Red/legend.png": 938,
	"./Lift-Symbol/legend.png": 939,
	"./Location-Green/legend.png": 940,
	"./Location-Red/legend.png": 941,
	"./Phone-Green/legend.png": 942,
	"./Phone-Red/legend.png": 943,
	"./Running-Man-Door-Symbol-Left/legend.png": 944,
	"./Running-Man-Door-Symbol-Right/legend.png": 945,
	"./Running-Man-Symbol/legend.png": 946,
	"./Site-Evacuator/legend.png": 947,
	"./Smoke-Detector-V1/legend.png": 948,
	"./Smoke-Detector-V2/legend.png": 949,
	"./Sprinkler-System/legend.png": 950,
	"./designated-smoking-area/legend.png": 951,
	"./direction-diagonal-bottom-left/legend.png": 952,
	"./direction-diagonal-bottom-right/legend.png": 953,
	"./direction-diagonal-top-left/legend.png": 954,
	"./direction-diagonal-top-right/legend.png": 955,
	"./direction-down/legend.png": 956,
	"./direction-left/legend.png": 957,
	"./direction-right/legend.png": 958,
	"./exit-down/legend.png": 959,
	"./exit-left/legend.png": 960,
	"./exit-stairs-down/legend.png": 961,
	"./fire-blanket/legend.png": 962,
	"./fire-exit-left/legend.png": 963,
	"./fire-exit-right/legend.png": 964,
	"./fire-extinguisher-CO2/legend.png": 965,
	"./no-smoking/legend.png": 966,
	"./warning/legend.png": 967,
	"./youAreHere/legend.png": 968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;